module.exports = {
	"ha": "fha",
	"id": 5.2,
	"report": {
		"ha": "Fraser Health",
		"group": "HSDA",
		"period": "2017 Q3–2018 Q2",
		"lastYear": "2018",
		"lastQuarter": "2"
	},
	"globalOptions": {
		"lang": {
			"numericSymbols": null
		}
	},
	"instr": {
		"chart": {
			"plotBackgroundColor": "#e1e2e4",
			"alignTicks": false,
			"width": 380,
			"height": 390,
			"marginTop": 100,
			"marginLeft": 10,
			"style": {
				"fontFamily": "Lato",
				"color": "#2c3e50"
			},
			"type": "column"
		},
		"credits": {
			"enabled": false
		},
		"legend": {
			"enabled": false
		},
		"tooltip": {
			"valueDecimals": 1,
			"valueSuffix": " %"
		},
		"title": {
			"align": "left",
			"x": -10,
			"useHTML": true,
			"text": "Figure 5.2 Estimated Cascade of Care for Fraser Health by Gender, Year Ending 2018 Q2 <sup style=\"font-size: 10px;\">7</sup>",
			"style": {
				"fontSize": "14px",
				"color": "#2c3e50"
			}
		},
		"plotOptions": {
			"series": {
				"marker": {
					"enabled": false
				},
				"dataLabels": {
					"allowOverlap": true,
					"useHTML": true,
					"style": {},
					"verticalAlign": "top"
				},
				"pointPadding": 0,
				"groupPadding": 0,
				"stacking": "normal",
				"colorByPoint": true
			},
			"column": {
				"colors": [
					"",
					"#043f61",
					"#0c4250",
					"#0d4440",
					"#09472e",
					"#0a4a23"
				]
			}
		},
		"xAxis": [
			{
				"lineWidth": 0,
				"tickWidth": 0,
				"labels": {
					"reserveSpace": false,
					"rotation": 270,
					"y": -100,
					"align": "left",
					"style": {
						"fontSize": "1.2em",
						"color": "white",
						"textOutline": "0.5px contrast"
					}
				},
				"categories": [
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					""
				]
			}
		],
		"yAxis": [
			{
				"height": "83%",
				"max": 100,
				"tickPosition": "inside",
				"lineColor": "#231f20",
				"lineWidth": 1,
				"tickColor": "#231f20",
				"tickInterval": 20,
				"minorTickPosition": "inside",
				"minorTickInterval": 10,
				"tickWidth": 1,
				"minorTickWidth": 1,
				"minorTickColor": "#231f20",
				"tickLength": 12,
				"minorTickLength": 8,
				"gridLineWidth": 0,
				"minorGridLineWidth": 0,
				"offset": 0,
				"title": {
					"text": "% of Diagnosed",
					"margin": -10,
					"x": -40
				},
				"labels": {
					"format": "{value}%"
				},
				"plotLines": [
					{
						"value": 0,
						"color": "black",
						"dashStyle": "solid",
						"width": 1,
						"zIndex": 100
					}
				]
			},
			{
				"top": "83%",
				"height": "17%",
				"tickPosition": "inside",
				"lineColor": "#9e1c20",
				"lineWidth": 1,
				"tickColor": "#9e1c20",
				"tickInterval": 20,
				"minorTickPosition": "inside",
				"minorTickInterval": 10,
				"tickWidth": 1,
				"minorTickWidth": 1,
				"minorTickColor": "#9e1c20",
				"tickLength": 12,
				"minorTickLength": 8,
				"gridLineWidth": 0,
				"minorGridLineWidth": 0,
				"offset": 0,
				"max": 0,
				"min": -20,
				"title": {
					"text": "% Loss from<br>Previous<br>Stage",
					"margin": -10,
					"style": {
						"color": "#9e1c20"
					},
					"x": -40
				},
				"labels": {
					"format": "{value}%",
					"style": {
						"color": "#9e1c20"
					},
					"zIndex": 1
				}
			}
		],
		"series": [
			{
				"name": "% of Diagnosed",
				"yAxis": 0,
				"data": [
					{
						"y": null
					},
					{
						"y": 96.61016949152543,
						"dataLabels": {
							"enabled": true,
							"format": "1653",
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": 87.31735827001754,
						"dataLabels": {
							"enabled": true,
							"format": "1494",
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": 83.86908240794857,
						"dataLabels": {
							"enabled": true,
							"format": "1435",
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": 78.43366452367036,
						"dataLabels": {
							"enabled": true,
							"format": "1342",
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": 67.27060198714202,
						"dataLabels": {
							"enabled": true,
							"format": "1151",
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": null
					},
					{
						"y": 94.9438202247191,
						"dataLabels": {
							"enabled": true,
							"format": "507",
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": 83.52059925093633,
						"dataLabels": {
							"enabled": true,
							"format": "446",
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": 79.21348314606742,
						"dataLabels": {
							"enabled": true,
							"format": "423",
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": 70.59925093632958,
						"dataLabels": {
							"enabled": true,
							"format": "377",
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": 57.30337078651685,
						"dataLabels": {
							"enabled": true,
							"format": "306",
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": null
					}
				],
				"table": {
					"visible": false
				}
			},
			{
				"name": "% Loss from Previous Stage",
				"yAxis": 1,
				"data": [
					{
						"y": null
					},
					{
						"y": -3.3898305084745783,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false,
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": -9.61887477313974,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false,
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": -3.9491298527443153,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false,
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": -6.480836236933795,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false,
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": -14.232488822652755,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false,
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": null
					},
					{
						"y": -5.0561797752809,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false,
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": -12.031558185404334,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false,
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": -5.156950672645744,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false,
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": -10.874704491725772,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false,
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": -18.832891246684348,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false,
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": null
					}
				],
				"table": {
					"visible": false
				}
			}
		],
		"groups": [
			{
				"x": 3,
				"text": "Men<br>n=1711"
			},
			{
				"x": 9,
				"text": "Women<br>n=534"
			}
		],
		"dataTable": {
			"Men": [
				1711,
				1653,
				1494,
				1435,
				1342,
				1151
			],
			"Women": [
				534,
				507,
				446,
				423,
				377,
				306
			]
		}
	},
	"callback": "C:\\Users\\Rafael\\Projects\\cfenet.ubc.ca-qmr\\src\\cli/callback.js",
	"outfile": "./temp/png/figure_fha_5_2.png"
};


//////////////////
// WEBPACK FOOTER
// ./temp/json/figure_fha_5_2.json
// module id = 200
// module chunks = 0